module.exports = __webpack_public_path__ + "media/Soft_supply_R3.f1977d3d.mp4";